import {
    FC,
    SignalPropsHandler,
    ExtendProps,
    PointLike,
    copyPointData,
    getTexture
} from '@gongxigames/framework/core/fragments/BuilderY';
import {Sprite as PixiSprite, BLEND_MODES, Texture } from 'pixi.js';
import {$Container, ContainerProps, ExtendContainerProps} from './Container';

export type SpriteProps = ExtendContainerProps<{
    anchor?: PointLike;
    blendMode?: BLEND_MODES;
    pluginName?: string;
    roundPixels?: boolean;
    texture?: Texture | string;
    tint?: number;
}, PixiSprite>;

const SPRITE_PROPS_LIST = ['anchor', 'blendMode', 'pluginName', 'roundPixels', 'texture', 'tint'] as const;
const spritePropsHandler = new SignalPropsHandler<SpriteProps, PixiSprite>()
    .propsToHandle(SPRITE_PROPS_LIST)
    .setHandlerFor('anchor', (val, obj) => copyPointData(val, obj.anchor))
    .setHandlerFor('texture', (val, obj) => obj.texture = getTexture(val));

/**
 * Component function that constructs
 * Pixi `Sprite` Element.
 * Use `texture` to specify custom texture or texture name from resources;
 */
export const $Sprite: FC<SpriteProps> = (props) => {
    const instance = props.instance ??= new PixiSprite();
    const unsubscribeProps = spritePropsHandler.apply(props, instance);

    instance.on('destroyed', unsubscribeProps);

    return $Container(props as ContainerProps);
};

// Helper types
export type ExtendSpritePropsSimple<T> = T & SpriteProps;
export type ExtendSpriteProps<T, REF = null> = ExtendProps<T, SpriteProps, REF>;
